import type {DataMessagePartComponent} from '@assistant-ui/react';
import React from 'react';

import type {WandbWorkspacePanelPart} from '../../../agentChat/store/thread';
import {MentionPill} from './MentionPill';

/**
 * WorkspacePanelMentionPart renders a workspace panel mention as an inline
 * pill.
 */
export const WorkspacePanelMentionPart: DataMessagePartComponent<
  WandbWorkspacePanelPart
> = ({data}) => (
  <MentionPill
    icon="panel"
    text={data.queryPanelTableKey ?? data.title ?? data.panelType}
  />
);
